module.exports = __webpack_public_path__ + "img/customer_icon2.480e6c10.png";